// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.header {
  background-color: black;
  color: white;
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.icon {
  align-self: flex-start;
}

.body {
  /* padding: 10px; */
}

.button {
  background-color: rgb(180, 180, 59);
  color: white;
  height: 20;
  padding: 10px;
  border-width: 0px;
}

/* table {
    font-family: arial, sans-serif;
    border-collapse: collapse;
    width: 50%;
  } */

td,
th {
  border: 0px solid #dddddd;
  text-align: left;
  padding: 8px;
}

/* tr:nth-child(even) {
        background-color: #dddddd;
      } */

.TryAgainButton {
  background-color: black;
  color: white;
  height: 20;
  margin-top: 25px;
  margin-bottom: 10px;
  padding: 10px;
  border-width: 0px;
}

.flexBody {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-top: 20px;
}

.side-heading {
  /* font-weight: normal; */
  font-size: 20px;
}

.footer1 {
  color: white;
  margin-bottom: 0px;
  border: 1px solid;
  align-items: center;
  display: flex;
  justify-content: center;
}

.paddingBottomZero {
  margin-bottom: 0px;
  margin-top: 0px;
}

/* h3 {
    font-size: 18px !important;
  } */

.invoice-row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 12px;
  border-top: 1px solid #e0e0e0;
}
.col-head {
  font-family: "HelveticaNeue-Bold", "Helvetica Neue Bold", "Helvetica Neue",
    sans-serif;
  font-size: 16px;
  font-weight: 700;
  color: #484b9f;
  text-align: left;
  margin-bottom: 12px;
  padding: 12px 12px 0px 12px;
}
.left-row {
  width: 150px;
  color:  #797979;
}
.invoice-body {
  width: 100%;
  padding: 16px;
  display: flex;
  flex-direction: column;
}
.invoice-total-cont {
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
}
.download-button {
  width: 100%;
  height: 60px;
  border-radius: 10px;
  background-color: #484b9f;
  box-sizing: border-box;
  border: 0;
  color: #ffffff;
  font-size: 20px;
}
.amount-details {
  border-radius: 10px;
  border: 1px solid #e0e0e0;
  background-color: #ffffff;
  padding: 16px;
  width: 28%;
  display: none;
}
.paid-date {
  border-radius: 5px;
  background-color: #77eebc;
  width: auto;
  font-family: "HelveticaNeue-Medium", "Helvetica Neue Medium", "Helvetica Neue",
    sans-serif;
  font-weight: 500;
  color: #126442;
  width: fit-content;
  padding: 10px;
}
table {
  border-collapse: collapse;
  width: 100%;
  /* margin: 20px; */
}
/* tr {
      border-bottom: 1px solid #ddd !important;
    } */

.total-details {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-content: center;
}
.footer-fee {
  display: flex;
  justify-content: space-between;
  padding-left: 20px;
}
.fee-p {
  font-family: "HelveticaNeue-Medium", "Helvetica Neue Medium", "Helvetica Neue",
    sans-serif;
  font-weight: 500;
  color: #333333;
  text-align: left;
  font-size: 20px;
}
.rs-p {
  box-sizing: border-box;
  font-family: "HelveticaNeue-Medium", "Helvetica Neue Medium", "Helvetica Neue",
    sans-serif;
  font-weight: 500;
  color: #333333;
  text-align: left;
  font-size: 25px;
}
.right-row {
  width: 100%;
  text-align: right;
  font-weight: 500;
  color: #333333;
  flex-grow: 1;
}
.right-row-id {
  margin-left: 10px;
  color: #2d8e64;
  width: 100%;
  text-align: right;
}

.svbk-invoice-logo {
  width: 100%;
  padding: 16px 16px 0px 16px;
  margin-bottom: 0px;
  align-self: center;
}
.invoice-card {
  width: 100%;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  margin-bottom: 16px;
}

.colon {
  display: none;
  padding: 0px 10px;
}

.row-text {
  font-size: 14px;
  padding: 0px;
  margin: 0px;
}

.sm-download-button {
  height: 45px;
  border-radius: 5px;
  font-size: 16px;
  margin-bottom: 16px;
}

.sm-download-button:active {
  opacity: 0.6;
}
.dark-text {
  font-weight: 500;
  color: #333333;
}

.footer-text {
  font-size: 16px;
  text-align: center;
}

.address-card{
  margin-top: 0px;
}

@media (max-width: 575.99px) {
  .table-from-medium-devices {
    display: none;
  }
}

@media (min-width: 1039px){
  .address-card{
    margin-top: 50px;
  }
}


@media (min-width: 576px) {
  .svbk-invoice-logo {
    width: 50%;
    width: 400px;
    align-self: stretch;
  }
  .invoice-body {
    flex-direction: row;
    padding: 16px;
    justify-content: space-between;
  }
  .invoice-total-cont {
    width: 65%;
    flex-direction: row;
    justify-content: space-between;
    border: 1px solid #e0e0e0;
    padding: 16px;
    border-radius: 10px;
    flex-wrap: wrap;
  }
  .invoice-card {
    width: 50%;
    min-width: 310px;
    border: none;
    border-radius: 0px;
    padding: 0px;
    margin-bottom: 0px;
  }
  .colon {
    display: inline;
  }
  .col-head {
    font-size: 24px;
  }
  .invoice-row {
    justify-content: flex-start;
    border: none;
  }
  .left-row {
    width: 180px;
  }
  .row-text {
    font-size: 16px;
  }
  .right-row {
    text-align: left;
    font-weight: 400;
  }
  .sm-download-button {
    display: none;
  }
  .amount-details{
    display: flex;
    align-self: flex-start;
    flex-direction: column;
  }
  .table-upto-small-devices {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/offlinePaymentStatus/OfflinePaymentStatus.css"],"names":[],"mappings":";;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,YAAY;EACZ,UAAU;EACV,aAAa;EACb,iBAAiB;AACnB;;AAEA;;;;KAIK;;AAEL;;EAEE,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;AACd;;AAEA;;SAES;;AAET;EACE,uBAAuB;EACvB,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;KAEK;;AAEL;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,6BAA6B;AAC/B;AACA;EACE;cACY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,SAAS;EACT,cAAc;EACd,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,UAAU;EACV,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX;cACY;EACZ,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;AACpB;AACA;;OAEO;;AAEP;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE;cACY;EACZ,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB;cACY;EACZ,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;;AAGA;EACE;IACE,UAAU;IACV,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE,mBAAmB;IACnB,aAAa;IACb,8BAA8B;EAChC;EACA;IACE,UAAU;IACV,mBAAmB;IACnB,8BAA8B;IAC9B,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,2BAA2B;IAC3B,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,sBAAsB;EACxB;EACA;IACE,aAAa;EACf;AACF","sourcesContent":["\n\n.header {\n  background-color: black;\n  color: white;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n}\n\n.icon {\n  align-self: flex-start;\n}\n\n.body {\n  /* padding: 10px; */\n}\n\n.button {\n  background-color: rgb(180, 180, 59);\n  color: white;\n  height: 20;\n  padding: 10px;\n  border-width: 0px;\n}\n\n/* table {\n    font-family: arial, sans-serif;\n    border-collapse: collapse;\n    width: 50%;\n  } */\n\ntd,\nth {\n  border: 0px solid #dddddd;\n  text-align: left;\n  padding: 8px;\n}\n\n/* tr:nth-child(even) {\n        background-color: #dddddd;\n      } */\n\n.TryAgainButton {\n  background-color: black;\n  color: white;\n  height: 20;\n  margin-top: 25px;\n  margin-bottom: 10px;\n  padding: 10px;\n  border-width: 0px;\n}\n\n.flexBody {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  padding-top: 20px;\n}\n\n.side-heading {\n  /* font-weight: normal; */\n  font-size: 20px;\n}\n\n.footer1 {\n  color: white;\n  margin-bottom: 0px;\n  border: 1px solid;\n  align-items: center;\n  display: flex;\n  justify-content: center;\n}\n\n.paddingBottomZero {\n  margin-bottom: 0px;\n  margin-top: 0px;\n}\n\n/* h3 {\n    font-size: 18px !important;\n  } */\n\n.invoice-row {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  padding: 12px;\n  border-top: 1px solid #e0e0e0;\n}\n.col-head {\n  font-family: \"HelveticaNeue-Bold\", \"Helvetica Neue Bold\", \"Helvetica Neue\",\n    sans-serif;\n  font-size: 16px;\n  font-weight: 700;\n  color: #484b9f;\n  text-align: left;\n  margin-bottom: 12px;\n  padding: 12px 12px 0px 12px;\n}\n.left-row {\n  width: 150px;\n  color:  #797979;\n}\n.invoice-body {\n  width: 100%;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n}\n.invoice-total-cont {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  background-color: #ffffff;\n}\n.download-button {\n  width: 100%;\n  height: 60px;\n  border-radius: 10px;\n  background-color: #484b9f;\n  box-sizing: border-box;\n  border: 0;\n  color: #ffffff;\n  font-size: 20px;\n}\n.amount-details {\n  border-radius: 10px;\n  border: 1px solid #e0e0e0;\n  background-color: #ffffff;\n  padding: 16px;\n  width: 28%;\n  display: none;\n}\n.paid-date {\n  border-radius: 5px;\n  background-color: #77eebc;\n  width: auto;\n  font-family: \"HelveticaNeue-Medium\", \"Helvetica Neue Medium\", \"Helvetica Neue\",\n    sans-serif;\n  font-weight: 500;\n  color: #126442;\n  width: fit-content;\n  padding: 10px;\n}\ntable {\n  border-collapse: collapse;\n  width: 100%;\n  /* margin: 20px; */\n}\n/* tr {\n      border-bottom: 1px solid #ddd !important;\n    } */\n\n.total-details {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-content: center;\n}\n.footer-fee {\n  display: flex;\n  justify-content: space-between;\n  padding-left: 20px;\n}\n.fee-p {\n  font-family: \"HelveticaNeue-Medium\", \"Helvetica Neue Medium\", \"Helvetica Neue\",\n    sans-serif;\n  font-weight: 500;\n  color: #333333;\n  text-align: left;\n  font-size: 20px;\n}\n.rs-p {\n  box-sizing: border-box;\n  font-family: \"HelveticaNeue-Medium\", \"Helvetica Neue Medium\", \"Helvetica Neue\",\n    sans-serif;\n  font-weight: 500;\n  color: #333333;\n  text-align: left;\n  font-size: 25px;\n}\n.right-row {\n  width: 100%;\n  text-align: right;\n  font-weight: 500;\n  color: #333333;\n  flex-grow: 1;\n}\n.right-row-id {\n  margin-left: 10px;\n  color: #2d8e64;\n  width: 100%;\n  text-align: right;\n}\n\n.svbk-invoice-logo {\n  width: 100%;\n  padding: 16px 16px 0px 16px;\n  margin-bottom: 0px;\n  align-self: center;\n}\n.invoice-card {\n  width: 100%;\n  border: 1px solid #e0e0e0;\n  border-radius: 10px;\n  margin-bottom: 16px;\n}\n\n.colon {\n  display: none;\n  padding: 0px 10px;\n}\n\n.row-text {\n  font-size: 14px;\n  padding: 0px;\n  margin: 0px;\n}\n\n.sm-download-button {\n  height: 45px;\n  border-radius: 5px;\n  font-size: 16px;\n  margin-bottom: 16px;\n}\n\n.sm-download-button:active {\n  opacity: 0.6;\n}\n.dark-text {\n  font-weight: 500;\n  color: #333333;\n}\n\n.footer-text {\n  font-size: 16px;\n  text-align: center;\n}\n\n.address-card{\n  margin-top: 0px;\n}\n\n@media (max-width: 575.99px) {\n  .table-from-medium-devices {\n    display: none;\n  }\n}\n\n@media (min-width: 1039px){\n  .address-card{\n    margin-top: 50px;\n  }\n}\n\n\n@media (min-width: 576px) {\n  .svbk-invoice-logo {\n    width: 50%;\n    width: 400px;\n    align-self: stretch;\n  }\n  .invoice-body {\n    flex-direction: row;\n    padding: 16px;\n    justify-content: space-between;\n  }\n  .invoice-total-cont {\n    width: 65%;\n    flex-direction: row;\n    justify-content: space-between;\n    border: 1px solid #e0e0e0;\n    padding: 16px;\n    border-radius: 10px;\n    flex-wrap: wrap;\n  }\n  .invoice-card {\n    width: 50%;\n    min-width: 310px;\n    border: none;\n    border-radius: 0px;\n    padding: 0px;\n    margin-bottom: 0px;\n  }\n  .colon {\n    display: inline;\n  }\n  .col-head {\n    font-size: 24px;\n  }\n  .invoice-row {\n    justify-content: flex-start;\n    border: none;\n  }\n  .left-row {\n    width: 180px;\n  }\n  .row-text {\n    font-size: 16px;\n  }\n  .right-row {\n    text-align: left;\n    font-weight: 400;\n  }\n  .sm-download-button {\n    display: none;\n  }\n  .amount-details{\n    display: flex;\n    align-self: flex-start;\n    flex-direction: column;\n  }\n  .table-upto-small-devices {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
